import { useProPilotStatus } from "PFApp/stores/propilot_lifecycle_store";
import { useState } from "react";
import { useMount } from "react-use";

import { PROPILOT_REGION_ID } from "../constants";
import { useIsProPilotEnabled } from "../hooks/use_is_propilot_enabled";
import { ProPilotSession } from "./components/propilot_session";
import { useDockZone } from "./hooks/use_dock_zone";

export const GlobalProPilot = () => {
  const enabled = useIsProPilotEnabled();
  const status = useProPilotStatus();
  const [floatingContainer, setFloatingContainer] = useState<HTMLElement | null>(null);
  const { dropZones, onDragOverZone, onDropInZone, onDragStateChange } = useDockZone();

  useMount(() => setFloatingContainer(document.getElementById(PROPILOT_REGION_ID)));

  if (!enabled || status === "off" || !floatingContainer) {
    return null;
  }

  return (
    <ProPilotSession
      status={status}
      container={floatingContainer}
      dropZones={dropZones}
      onDragOverZone={onDragOverZone}
      onDropInZone={onDropInZone}
      onDragStateChange={onDragStateChange}
    />
  );
};
